module.exports = __webpack_public_path__ + "img/2.ed6a21db.png";